export default __webpack_public_path__ + "static/media/a016-1.1485c69d.jpg";